import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageContainer from '../../components/layout/PageContainer/PageContainer';

export const ComparisonSuccess: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        type: 'email_signup',
      });
    }
  }, []);

  return (
    <PageContainer>
      <div className="flex items-center justify-center py-16">
        <div className="max-w-md w-full text-center">
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
            style={{ background: '#EEF7F3' }}
          >
            <svg
              className="w-8 h-8"
              style={{ color: '#2A7D5F' }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-secondary mb-3">You're all set</h1>
          <p className="text-gray-500 mb-10">
            Your comparison results are on their way. While you wait, see what WebLeads finds for
            your industry, free.
          </p>

          <a
            href="https://app.webleads.site/register"
            className="block w-full bg-primary text-white py-4 rounded-xl font-semibold text-lg hover:bg-primary-hover shadow-elevated hover:shadow-lg hover:-translate-y-0.5 transition-all mb-4"
          >
            Start Finding Leads
          </a>
          <p className="text-sm text-gray-400 mb-10">No credit card required. 2 free searches included.</p>

          <button
            onClick={() => navigate('/comparison-tool')}
            className="text-sm text-gray-400 hover:text-gray-600 transition-colors"
          >
            Back to comparison tool
          </button>
        </div>
      </div>
    </PageContainer>
  );
};

export default ComparisonSuccess;
